import React from 'react';
import { observer } from 'mobx-react';
import {
  BrowserRouter as Router, RouteComponentProps, Switch, Route
} from "react-router-dom";
import IndexRole from './IndexRole';
import NewRole from './NewRole';
import EditRole from './EditRole';

interface RoleProps extends RouteComponentProps {
  changeToggle(action?: boolean): void
}

@observer export default class Role extends React.Component<RoleProps> {
  render() {
    return (
      <Router>
        <Switch >
          <Route exact path="/roles"
            render={(props) => (
              <IndexRole {...props} changeToggle={this.props.changeToggle} />
            )}>
          </Route>
          <Route exact path="/roles/nuevo"
            render={(props) => (
              <NewRole {...props} changeToggle={this.props.changeToggle} />
            )}>
          </Route>
          <Route exact path="/roles/:id"
            render={(props) => (
              <EditRole {...props} changeToggle={this.props.changeToggle} />
            )}>
          </Route>
        </Switch>
      </Router>
    )
  }
}